// extracted by mini-css-extract-plugin
module.exports = {"nav":"style__nav__aWJ1w"};